module.exports = __webpack_public_path__ + "static/img/icon2-3.c15b9423.svg";